import { render } from "./Strip.vue?vue&type=template&id=36b90437&scoped=true"
import script from "./Strip.vue?vue&type=script&lang=js"
export * from "./Strip.vue?vue&type=script&lang=js"

import "./Strip.vue?vue&type=style&index=0&id=36b90437&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b90437"]])

export default __exports__